import { render, staticRenderFns } from "./MonthlyEPFMaybank.vue?vue&type=template&id=aee26158&scoped=true"
import script from "./MonthlyEPFMaybank.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFMaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee26158",
  null
  
)

export default component.exports